import React from 'react';

/**
 * onKeyDown handler for non-interactive elements acting as buttons.
 * Enter/Space triggers the onClick action.
 */
export function handleButtonKeyDown(e: React.KeyboardEvent, onClick?: () => void) {
    if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick?.();
    }
}
